// import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { coy, dark } from "react-syntax-highlighter/dist/esm/styles/prism";

import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import { COURSE_BASE_URL } from "../../services/courseService";
import Loading from "../../utils/Loading";
import { format } from "date-fns";
import { getRoleDisplay } from "../../utils/getRoleDisplay";
import Swal from "sweetalert2";

export const CourseContentDetails = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [course, setCourse] = useState({
    title: "",
    instructor: "",
    credit: "",
    price: "",
    category: "",
    description: "",
    numberOfCourses: "",
    courseRating: "",
    createdAt: "",
  });

  // const deleteCourse = async (e, _id, user, setError)
  const deleteCourse = async (e, _id) => {
    e.preventDefault();

    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmResult.isConfirmed) {
        const response = await fetch(
          `${COURSE_BASE_URL}/api/courses/list/delete/${_id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        const json = await response.json();

        if (!response.ok) {
          throw new Error(json.message || "Failed to delete course");
        }

        Swal.fire({
          title: "Deleted!",
          text: "Course has been deleted.",
          icon: "success",
          timer: 2000,
        });
        navigate("/api/dashboard/course-table");
        //  fetchCourseData(); // reload courses list right away
      }
    } catch (error) {
      console.error("Error deleting course: ", error.message);

      // Display the error using Swal or by updating the state
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to delete course!",
        icon: "error",
      });

      // Alternatively, you could update the state to show the error message on the page
      setError(error.message || "Failed to delete course!");
    }
  };

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const response = await fetch(
          `${COURSE_BASE_URL}/api/courses/list/${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch course data");
        }
        const data = await response.json();
        setCourse(data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchCourseData();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error.message}</div>;
  }
  return (
    <section className="course-content-details text-muted">
      <div className="container  bg-white p-3 mt-3  mb-4">
        <h2 className="bg-white">
          Course Content Details <hr />
        </h2>
        <h6>Course Title: {course.title}</h6>
        <p>
          <b>Instructor Name:</b> <small>{course.instructor} </small>
        </p>
        <div className="row">
          <div className="col bg-white border p-3 text-dark">
            <b>
              Price:{" "}
              <span className="text-danger">
                {" "}
                {parseFloat(course.price).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </b>
          </div>
          {/* 3 row */}
          <div className="col border p-3 text-dark">
            <b>Category: </b>
            <small>{course.category}</small>
          </div>
          <div className="col bg-white border text-dark p-3">
            <small>
              <b>Course Credit:</b> {course.credit}
            </small>
          </div>
          {/* 4 row */}
          <div className="col bg-white border text-dark p-3">
            <b>Number of Courses: </b>
            <small>{course.numberOfCourses}</small>
          </div>
        </div>{" "}
        <hr />
        {/* 2nd row */}
        <div className="row mt-4 mb-4">
          <div className="col card">
            <h4>Course Description</h4>

            {/* <ReactMarkdown>{course.description}</ReactMarkdown> */}
            <div className="accordion" id="courseAccordion">
              {course.lessons.map((lesson, lessonIndex) => (
                <div className="accordion-item" key={lessonIndex}>
                  <h2
                    className="accordion-header"
                    id={`heading-${lessonIndex}`}
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse-${lessonIndex}`}
                      aria-expanded="true"
                      aria-controls={`collapse-${lessonIndex}`}
                    >
                      Lesson {lessonIndex + 1}: {lesson.lessonTitle}
                    </button>
                  </h2>
                  <div
                    id={`collapse-${lessonIndex}`}
                    className={`accordion-collapse collapse ${
                      lessonIndex === 0 ? "show" : ""
                    }`}
                    aria-labelledby={`heading-${lessonIndex}`}
                    data-bs-parent="#courseAccordion"
                  >
                    <div className="accordion-body">
                      {/* Display video */}
                      <video
                        width="100%"
                        height="200"
                        controls
                        className="mb-3"
                      >
                        <source src={lesson.content} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      {/* Display topics */}
                      {lesson.topics.map((topic, topicIndex) => (
                        <div key={topicIndex} className="mb-2">
                          <h6>
                            Topic {topicIndex + 1}: {topic.title}
                          </h6>
                          <p>{topic.content}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <hr />
        <p>
          <b className="text-dark">Published Date: </b>
          {format(new Date(course.createdAt), "MMMM d, yyyy")}{" "}
        </p>
        <hr />
        {/* Course Actions */}
        <div className="row" style={{ marginTop: "10%" }}>
          <div className="col">
            {" "}
            <Link
              className="btn btn-outline-secondary btn-lg text-uppercase"
              to={"/api/dashboard/course-table"}
            >
              <>
                {" "}
                <i className="fa fa-chevron-left" aria-hidden="true"></i> &nbsp;
                Back
              </>
            </Link>
          </div>
          <div className="col">
            {/* Delete course */}
            {/* getRoleDisplay()  */}
            {user && user.role.isAdmin && (
              <button
                type="button"
                className="btn btn-outline-danger btn-lg text-uppercase"
                onClick={(e) => deleteCourse(e, course._id)}
              >
                {!error && loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-3"
                      role="status"
                      aria-hidden="true"
                      style={{ width: "1.5rem", height: "1.5rem" }}
                    ></span>
                    <small className="text-muted" style={{ fontSize: "12px" }}>
                      Please wait...
                    </small>
                  </>
                ) : (
                  <>
                    {" "}
                    <i className="fa fa-trash"></i> &nbsp; Delete course
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
